'use strict';

exports.__esModule = true;

var _domApi = require('../cpp/domApi');

exports['default'] = function (oldVnodePtr, vnodePtr, elmPtr) {
  var oldRaws = window.asmDomHelpers.vnodesData[oldVnodePtr];
  var newRaws = window.asmDomHelpers.vnodesData[vnodePtr];
  if (oldRaws !== undefined) oldRaws = oldRaws.raw;
  if (newRaws !== undefined) newRaws = newRaws.raw;

  if (oldRaws === undefined && newRaws === undefined || oldRaws === newRaws) return;
  if (oldRaws === undefined) oldRaws = {};
  if (newRaws === undefined) newRaws = {};

  var elm = _domApi.nodes[elmPtr];

  for (var key in oldRaws) {
    if (newRaws[key] === undefined) {
      elm[key] = undefined;
    }
  }

  for (var _key in newRaws) {
    if (oldRaws[_key] !== newRaws[_key] || (_key === 'value' || _key === 'checked') && elm[_key] !== newRaws[_key]) {
      elm[_key] = newRaws[_key];
    }
  }

  elm.asmDomRaws = Object.keys(newRaws);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/asm-dom/lib/js/diff.js
// module id = 7
// module chunks = 2